export default {"src":"/_next/static/media/download.3e41d77f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};